import api from './api'

/**
 * Counselor-level parent notification preferences (Configured Updates).
 * GET/PATCH /counselor/parent-notification-preferences
 */
export const getCounselorParentNotificationPreferences = () =>
	api.get('/counselor/parent-notification-preferences')

export const patchCounselorParentNotificationPreferences = body =>
	api.patch('/counselor/parent-notification-preferences', body)

/**
 * Counselor-level parent contacts (all students in scope, one request).
 * GET /counselor/parent-contacts
 */
export const getCounselorParentContacts = () =>
	api.get('/counselor/parent-contacts')

/**
 * Per-student parent contacts.
 */
export const listParentContacts = (studentId, { includeInactive = false } = {}) =>
	api.get(`/counselor/students/${encodeURIComponent(studentId)}/parent-contacts`, {
		params: includeInactive ? { include_inactive: true } : undefined,
	})

export const createParentContact = (studentId, body) =>
	api.post(`/counselor/students/${encodeURIComponent(studentId)}/parent-contacts`, body)

export const updateParentContact = (studentId, contactId, body) =>
	api.put(
		`/counselor/students/${encodeURIComponent(studentId)}/parent-contacts/${encodeURIComponent(contactId)}`,
		body,
	)

export const deleteParentContact = (studentId, contactId) =>
	api.delete(
		`/counselor/students/${encodeURIComponent(studentId)}/parent-contacts/${encodeURIComponent(contactId)}`,
	)

/**
 * Bulk CSV import.
 */
export const bulkImportParentContacts = file => {
	const formData = new FormData()
	formData.append('file', file)
	return api.post('/counselor/parent-contacts/bulk-import', formData, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})
}

export const downloadParentContactsImportTemplate = () =>
	api.get('/counselor/parent-contacts/bulk-import/template', {
		responseType: 'blob',
	})

/**
 * Counselor-wide parent email delivery logs (event-grouped with nested recipients).
 * GET /counselor/parent-email-delivery-logs
 * Optional limit uses backend default when omitted.
 */
export const getCounselorParentEmailDeliveryLogs = ({ limit } = {}) =>
	api.get('/counselor/parent-email-delivery-logs', {
		params: limit != null ? { limit } : undefined,
	})
